export const UPDATE_RECEIPT = 'UPDATE_RECEIPT'
export const UPDATE_RECEIPT_FAILED = 'UPDATE_RECEIPT_FAILED'
export const UPDATE_RECEIPT_SUCCEEDED = 'UPDATE_RECEIPT_SUCCEEDED'
